import { creditsApi } from '../api/creditsApi';

function isPresentScore(value) {
  return value !== null && value !== undefined && value !== '';
}

export function getJobIdsFromBlockedCredits({ companyId } = {}) {
  if (!companyId) return [];
  const summary = creditsApi.getSummary({ companyId });
  const jobIds = new Set();

  Object.values(summary.blocks || {}).forEach((entry) => {
    if (entry?.status !== 'blocked') return;
    const jobId = entry?.metadata?.jobId;
    if (jobId) jobIds.add(jobId);
  });

  return Array.from(jobIds);
}

// Best-effort reconciliation from raw candidate rows (as returned by candidatelist endpoints).
// Consumes a blocked credit when a score is present for the test type.
export function reconcileCreditsFromCandidatesRaw({ companyId, candidates = [], fallbackJobId } = {}) {
  if (!companyId || !Array.isArray(candidates) || candidates.length === 0) return;

  candidates.forEach((c) => {
    const candidateIdOrEmail = c?.email || c?.candidate_email || c?.id;
    const jobId = c?.job_id || c?.jobId || fallbackJobId;
    if (!candidateIdOrEmail || !jobId) return;

    const scoreMap = {
      screening: c?.screening_overall_score,
      personality: c?.personality_overall_score,
      behavioral: c?.behavioral_overall_score,
      coding: c?.coding_overall_score,
    };

    Object.entries(scoreMap).forEach(([testType, score]) => {
      if (!isPresentScore(score)) return;

      const refKey = creditsApi.makeRefKey({
        companyId,
        jobId,
        candidateIdOrEmail,
        testType,
      });

      creditsApi.consumeBestEffort({
        companyId,
        refKey,
        match: { jobId, candidateIdOrEmail, testType },
      });
    });
  });
}

export async function reconcileCreditsByBlockedJobIds({ companyId, getApiUrl, fetchImpl = fetch } = {}) {
  if (!companyId || typeof getApiUrl !== 'function') return;

  const jobIds = getJobIdsFromBlockedCredits({ companyId });
  if (!jobIds.length) return;

  for (const jobId of jobIds) {
    try {
      const url = getApiUrl(`/api/candidatelist?jobId=${encodeURIComponent(jobId)}`);
      const resp = await fetchImpl(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
      if (!resp.ok) continue;

      const data = await resp.json();
      const candidates = Array.isArray(data) ? data : (data.candidates || []);

      reconcileCreditsFromCandidatesRaw({ companyId, candidates, fallbackJobId: jobId });
    } catch (e) {
      // swallow
    }
  }
}

